<template>
  <div>
    <el-tabs type="border-card" v-model="activeName">
<!--      <el-tab-pane label="受入型材" name="xingcai"><ShouRuXingCaiPage v-if="this.activeName === 'xingcai'" :parentData = 'false'/></el-tab-pane>-->
      <el-tab-pane label="受入型材" name="xingcai1"><ShouRuXingCaiPage1 v-if="this.activeName === 'xingcai1'" :parentData = 'false'/></el-tab-pane>
      <!-- <el-tab-pane label="受入玻璃" name="boli"><ShouRuBoLiPage v-if="this.activeName === 'boli'" :parentData = 'false'/></el-tab-pane>-->
<!--      <el-tab-pane label="受入部品" name="bupin"><ShouRuBuPinPage v-if="this.activeName === 'bupin'"/></el-tab-pane>-->
      <!-- <el-tab-pane label="涂装检查" name="tuzhuang"><TuZhuangZhiJianPage v-if="this.activeName === 'tuzhuang'" :parentData = 'false'/></el-tab-pane>-->
      <!-- <el-tab-pane label="组立检查" name="zuli"><ZuLiZhiJianPage v-if="this.activeName === 'zuli'" :parentData = 'false'/></el-tab-pane>-->
<!--      <el-tab-pane label="再手配" name="zaishoupei"><ZaiShouPeiPage v-if="this.activeName === 'zaishoupei'" :parentData = 'false'/></el-tab-pane>-->
<!--      <el-tab-pane label="组立直行率" name="zhixing"><ZuLiZhiXingPage v-if="this.activeName === 'zhixing'" :parentData = 'false'/></el-tab-pane>-->
      <!-- <el-tab-pane label="组立品质指标" name="jiagong"><ZuLiBuLiangPage v-if="this.activeName === 'jiagong'" :parentData = 'false'/></el-tab-pane>-->
<!--      <el-tab-pane label="切断加工" name="qieduanjiagong"><CutOffProcessAccumulateBad v-if="this.activeName === 'qieduanjiagong'" :parentData = 'false'/></el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import ShouRuBoLiPage from "./ShouRuBoLiPage";
// import ShouRuXingCaiPage from "./ShouRuXingCaiPage";
/*import ShouRuBuPinPage from "@/views/applications/sys/components/ShouRuBuPinPage";*/
/*import JiaGongZhiJianPage from "@/views/applications/sys/components/JiaGongZhiJianPage";*/
import ZuLiZhiJianPage from "./ZuLiZhiJianPage";
/*import ZuLiZhiXingPage from "./ZuLiZhiXingPage";*/
// import ZaiShouPeiPage from "./ZaiShouPeiPage";
// import ZaiShouPeiPage from "@/views/applications/dc/ZspPage";
import ZuLiBuLiangPage from "@/views/applications/bus/homePage/ZuLiBuLiangPage";
import TuZhuangZhiJianPage from "@/views/applications/bus/homePage/TuZhuangZhiJianPage";
// import CutOffProcessAccumulateBad from "@/views/applications/bus/make_schedule/dp/CutOffProcessAccumulateBad";
import ShouRuXingCaiPage1 from "@/views/applications/bus/homePage/ShouRuXingCaiPage1";
export default {
  name: "HomePage1",
  components:{
    // CutOffProcessAccumulateBad,
    // ShouRuXingCaiPage,
    ShouRuXingCaiPage1,
    ShouRuBoLiPage,
    /*ShouRuBuPinPage,*/
   /* JiaGongZhiJianPage,*/
    ZuLiZhiJianPage,
    /*ZuLiZhiXingPage,*/
    // ZaiShouPeiPage,
    ZuLiBuLiangPage,
    TuZhuangZhiJianPage
  },
  data(){
    return{
      activeName: 'xingcai1'
    }
  },
  methods: {
  },
  created() {

  }
}
</script>

<style scoped>

</style>